const ClientTermTemplateList_query = `
    query(
      $clientId: Int!
      $showAllForList: Boolean!
    ) {
      clientTermTemplateList(
        clientId: $clientId
        showAllForList: $showAllForList
      ) {
          termTemplateId
          termTemplateUuid
          clientId
          {
            clientId
            name            
          }
          name
          description
          noOfSeats
          noOfWeeks
          noOfPeriods
          createDate
          updateDate
          
      }
    }
`;

const CreateTermTemplate_mutate = `
    mutation createTermTemplate(
      $name: String!
      $description: String!
      $clientId: Int!      
      $noOfSeats: Int!
      ) {
      createTermTemplate(
        name: $name,
        description: $description,
        clientId: $clientId,        
        noOfSeats: $noOfSeats ) {
        termTemplate
        {
          termTemplateId
          clientId
          {
            name
          }
          name
          description
          noOfSeats
          noOfPeriods
          noOfWeeks
        }
      }
    }
`;

const GetTermTemplateDataByName_query = `
    query( $name: String! , $clientId: Int! , $termTemplateId: Int)
    {
      getTermTemplateDataByName(name:$name,clientId:$clientId,termTemplateId:$termTemplateId)
      {
          termTemplateId
          clientId
          {
            name
          }
          name
          description
          noOfSeats
          noOfPeriods
          noOfWeeks
      }
    }
`;

const GetTermTemplateDataById_query = `
    query( $termTemplateId: Int!)
    {
      getTermTemplateDataById(termTemplateId:$termTemplateId)
      {
          termTemplateId
          clientId
          {
            name
          }
          name
          description
          noOfSeats
          noOfPeriods
          noOfWeeks
      
      }
    }
`;

const EditTermTemplate_mutate = `
    mutation editTermTemplate(
      $termTemplateId: Int!
      $name: String!
      $description: String!
      $clientId: Int!      
      $noOfSeats: Int!
      ) {
      editTermTemplate(
        termTemplateId: $termTemplateId,
        name: $name,
        description: $description,
        clientId: $clientId,        
        noOfSeats: $noOfSeats ) {
        termTemplate
        {
          termTemplateId
          clientId
          {
            name
          }
          name
          description
          noOfSeats
          noOfPeriods
          noOfWeeks
        }
      }
    }
`;

const EditTermTemplateName_mutate = `
    mutation editTermTemplateName(
      $termTemplateId: Int!
      $name: String!
      
      ) {
      editTermTemplateName(
        termTemplateId: $termTemplateId,
        name: $name ) {
        termTemplate
        {
          termTemplateId
          clientId
          {
            name
          }
          name
          description
          noOfSeats
          noOfPeriods
          noOfWeeks
        }
      }
    }
`;

const DeleteTermTemplate_mutate = `mutation deleteTermTemplate(
  $termTemplateUuid:String!
  ){
  deleteTermTemplate(
    termTemplateUuid: $termTemplateUuid,
  ){
    response
  }
}`;

const GetTermTemplateDataByUuid_query = `query($termTemplateUuid: String!){
  getTermTemplateDataByUuid(termTemplateUuid:$termTemplateUuid)
  {
    termTemplateId
    clientId{
      name
    }
    name
    description
    noOfSeats
    noOfPeriods
    noOfWeeks
  }
}
`;

module.exports = {
  CLIENT_TERM_TEMPLATE_LIST_QUERY: ClientTermTemplateList_query,
  CREATE_TERM_TEMPLATE_MUTATION: CreateTermTemplate_mutate,
  GET_TERM_TEMPLATE_DATA_BY_NAME: GetTermTemplateDataByName_query,
  GET_TERM_TEMPLATE_DATA_BY_ID: GetTermTemplateDataById_query,
  EDIT_TERM_TEMPLATE_MUTATION: EditTermTemplate_mutate,
  EDIT_TERM_TEMPLATE_NAME_MUTATION: EditTermTemplateName_mutate,
  DELETE_TERM_TEMPLATE_MUTATION: DeleteTermTemplate_mutate,
  GET_TERM_TEMPLATE_DATA_BY_UUID: GetTermTemplateDataByUuid_query,
};
